import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ReCaptchaV3Service } from 'ng-recaptcha';
import { LandingService } from 'src/app/rest_services/landing.service';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  contactForm: FormGroup;

  constructor(private recaptchaV3Service: ReCaptchaV3Service,private formBuilder: FormBuilder,
    private mailService: LandingService
  ) {
    this.removeCssById("css_landing");
    this.loadStyle("assets/index/css/vendor/font-awesome.css");
    this.loadStyle("assets/index/css/vendor/slick.css");
    this.loadStyle("assets/index/css/vendor/slick-theme.css");
    this.loadStyle("assets/index/css/vendor/animate/animate.min.css");
    this.loadStyle("assets/index/app.css");
    this.loadScript("assets/index/app.js");
    this.loadScript("assets/index/js/slick.min.js");

    this.contactForm = this.formBuilder.group({
      name: ['', Validators.required],
      phone: ['', [Validators.required, Validators.pattern(/^(?:\+212|0)[5-7]\d{8}$/)]],
      email: ['', [Validators.required, Validators.email, mailService.noDisposableEmail()]],
      object: ['', [Validators.required, Validators.maxLength(100), Validators.minLength(3)]],
      structure: ["Non précisée", Validators.required],
      message: ['', Validators.required],
      conditions: ['', Validators.required]
    });
   }

  mobile:any=false;
  medium:any=false;
  loading:any=false;
  ngOnInit(): void {
    $("#preloader").show("slow");
    $(".logo_navbar").css("max-width","8% !important");
    
    this.preloader();
    setTimeout(()=>{
      let footer:any = document.getElementsByClassName("footer-section");      
      footer[0].style.display = "none";
    },2000);

    if (window.screen.width <= 768) { // 768px portrait
      this.mobile = true;
      if (window.screen.width > 668) this.medium = true;
    }else {
      this.mobile = false;
    }
    $(document).ready(function(){
      $(".mobile-nav__wrapper").removeClass("expanded");
      $("body").removeClass("locked");
    });
  }

  public loadScript(scripts:string) {
    let node = document.createElement("script");
    node.src = scripts;
    node.type = "text/javascript";
    node.async = true;
    var scriptsTags = document.getElementsByTagName('script');
    for (var i = scriptsTags.length; i--;) {
        if (scriptsTags[i].src != scripts) {
          document.getElementsByTagName("body")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  public loadStyle(link:string) {
    let node = document.createElement("link");
    node.href = link;
    node.type = "text/css";
    node.id = "css_landing";
    node.rel ="stylesheet";
    var linksTags = document.getElementsByTagName('link');
    for (var i = linksTags.length; i--;) {
        if (linksTags[i].href != link) {
          document.getElementsByTagName("head")[0].appendChild(node);
          // break;
        }else {
          break;
        }
    }
  }
  preloader () {
    setTimeout(function () {
      $("#preloader").hide("slow");
    }, 1500);
    setTimeout(function () {
      $(".footer-section").css("display","none !important")
    }, 5000);
  }
  removeCssById(id: string) {
    const styleElement = document.getElementById(id);
    if (styleElement) {
      styleElement.remove(); // Removes the element from the DOM
    } else {
      console.warn(`No CSS found with id '${id}'`);
    }
  };

  showSuccess:boolean = false;
  showFailed:boolean = false;
  send(): void {  
    this.loading = true;  
    if (this.contactForm.value.invalid || !this.contactForm.value.conditions ) {
      console.log("invaliddd");
      console.log(this.contactForm.value.controls);
      $('.alert-danger').addClass('fadeIn');
      $('.alert-danger').removeClass('fadeOut');
      setTimeout(function () {
        $('.alert-danger').removeClass('fadeIn');
      }, 7000);
      if(this.contactForm.value.controls!=undefined){
        for (const control of Object.keys(this.contactForm.value.controls)) {
          this.contactForm.value.controls[control].markAsTouched();
        } 
      }
      this.loading = false;
    }else {
      this.recaptchaV3Service.execute('importantAction')
      .subscribe((token: string) => {
        console.log(this.contactForm.value);
        this.mailService.sendContact(this.contactForm.value).then(response => {
          console.log(response);
          if (response === "sent") {
            $('.alert-success').addClass('fadeIn').removeClass('fadeOut');
            setTimeout(() => {
              $('.alert-success').removeClass('fadeIn');
            }, 7000);
          } else {
            $('.alert-danger').addClass('fadeIn').removeClass('fadeOut');
            setTimeout(() => {
              $('.alert-danger').removeClass('fadeIn');
            }, 7000);
          }
        
          this.loading = false;
        });
      });
    }
  }
}
